import $ from 'jquery'
import { uploadImg } from '@/api/index/'

export default {
  async uploadImage () {
    let inputStr = `<input type="file" style="display:none" accept="image/*" id="browserFile" />`
    $('body').append(inputStr)
    let browserFile = $('#browserFile')

    // function fileChangeHandler (e) {
    //   console.log(e.file, 'e')
    //   browserFile.remove()
    // }

    // window.fileChangeHandler = fileChangeHandler
    return new Promise((rev, rej) => {
      browserFile.change(async function () {
        let file = this.files[0]
        let formData = new FormData()
        formData.append('file', file)

        let res = await uploadImg(formData)
        browserFile.remove()

        rev(res.data.rows)
      })

      browserFile.click()
    })
  }
}